<template>
    <div id="TableTask">
        <VisitorTaskListView 
            :tableRecord="recordId" 
            :showCreateButton="true"
            ref="taskListView" 
        />
    </div>
</template>

<script>
import VisitorTaskListView from "../../../../../components/task/VisitorTaskListView.vue";

export default {
    name: "TableTask",
    props: {
        recordId: {
            type: String,
            required: true,
        },
    },
    components: {
        VisitorTaskListView,
    },
    methods: {
        refreshTable() {
            if (this.$refs.taskListView) {
                this.$refs.taskListView.refreshTable();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#TableTask {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
